import { cva } from "cva";

export const expandingMenuTriggerStyles = cva({
  base: "bg-transparent w-full flex items-center justify-between cursor-pointer py-20 px-horizontal-margin transition-colors duration-150 ease-out-quad",
});

export const expandingMenuTriggerTextStyles = cva({
  base: "flex-1 text-ginto-23 font-normal leading-130 text-left",
});

export const expandingMenuTriggerIconStyles = cva({
  base: "w-24 h-24 flex items-center justify-center fill-current transition-transform duration-450 ease-out-expo will-change-transform [&>svg]:w-18 [&>svg]:h-auto",
  variants: {
    expanded: {
      true: "-rotate-180",
    },
  },
});
